import { createApp } from 'vue'
import App from './App.vue'
import router from '../src/router'
import store from '../BLL/store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

createApp(App).use(store).use(router).mount('#app')
